/**
 * @generated SignedSource<<c041283479cf83a7c4d2a1754f68765d>>
 * @relayHash 44048662173c9a8d67e2b70cea236d19
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5c6df45c9840fea3747be12847542f0209273460c73ea85ae0655b140b7f3347

import type { ConcreteRequest, Query } from 'relay-runtime';
export type GrowthUnifiedProfileTrialType = "AUTO_UPGRADE" | "DIRECT_TRIAL" | "MANUAL_TRIAL" | "REVERSE_TRIAL" | "%future added value";
export type AsyncEligibilityConditionsQuery$variables = {
  entitlementId: string;
};
export type AsyncEligibilityConditionsQuery$data = {
  readonly growthUnifiedProfile_getEntitlementProfile: {
    readonly lastKnownTrial: {
      readonly trialEndTimeStamp: number | null | undefined;
      readonly trialType: GrowthUnifiedProfileTrialType | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type AsyncEligibilityConditionsQuery = {
  response: AsyncEligibilityConditionsQuery$data;
  variables: AsyncEligibilityConditionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "entitlementId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "entitlementId",
        "variableName": "entitlementId"
      }
    ],
    "concreteType": "GrowthUnifiedProfileEntitlementProfileResult",
    "kind": "LinkedField",
    "name": "growthUnifiedProfile_getEntitlementProfile",
    "plural": false,
    "selections": [
      {
        "concreteType": "GrowthUnifiedProfileEntitlementContextTrialResult",
        "kind": "LinkedField",
        "name": "lastKnownTrial",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "trialEndTimeStamp"
          },
          {
            "kind": "ScalarField",
            "name": "trialType"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "AsyncEligibilityConditionsQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AsyncEligibilityConditionsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "5c6df45c9840fea3747be12847542f0209273460c73ea85ae0655b140b7f3347",
    "metadata": {},
    "name": "AsyncEligibilityConditionsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9258ec89c4d87b2dd2877a8cdc9439ca";

export default node;
